import { Component, OnInit,ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AngularFireAuth } from 'angularfire2/auth';
import { ConfirmacionesService } from '../../services/confirmaciones.service';
import { GoogleMapaService } from '../../services/google-map.service'
import { ClientesService } from '../../services/clientes.service';
import { ServiciosService } from '../../services/servicios.service';

import { imgCotizacion,monosVerdes, confirmRules } from '../cotizacion/imagenes-base'

declare var google: any;
declare let jsPDF;
declare var window;
declare var require: any;

const ioBarcode = require('io-barcode');

//Pipes ocupado para generar correctamente l informacion de los pdf
import {ServicioBuscarGeoCode} from "../../services/geocoding.service";
import {ContactosService} from "../../services/contactos.service";
import {UsuariosPersonalService} from '../../services/usuarios-personal.service';
import {PagosService} from '../../services/pagos-service.service';
import {CotizacionesService} from '../../services/cotizaciones.service';
@Component({
  selector: 'app-confirmacion',
  templateUrl: './confirmacion.component.html',
  styleUrls: ['../cotizacion/cotizacion.css']
})

export class ConfirmacionComponent implements OnInit {

    constructor(
        private activatedRoute:ActivatedRoute,
        private confirmacionesService : ConfirmacionesService,
        private contactosService:ContactosService,
        private servicioGeoCode:ServicioBuscarGeoCode,
        private serviciosService:ServiciosService,
        private afAuth:AngularFireAuth,
        private pagosServive :PagosService,
        private googleService:GoogleMapaService,
        private servicioService:ServiciosService,
        private clienteServices:ClientesService,
        private personalService:UsuariosPersonalService,
        private cdRef:ChangeDetectorRef,
        private cotizacionesService:CotizacionesService
    ){}

    cuentaPorPagar = {requiereFactura:true}
    fechaActual:number;
    opcion:any='unidades';
    confirmacion:Observable<any>;
    confirmacionId:any;
    arregloServicios=[];
    arregloParadas=[];
    totalConceptos:number;
    codigoDeBarrasOxxo:any;
    codigoDeBarrasOxxoImagen:any;
    confirmacionCompleta:any={};
    esPago:boolean=false;
    confirmacion_cancelada:boolean=false;

    //Variables para el PDF
    nombreCliente:any;
    nombreContratante:any;
    telefonoContratante:any;
    nombreUsuario:any;
    telefonoUsuario:any;
    nombreCoordinador:any;
    telefonoCoordinador:any;
     //variables para el mapa
     private map: any;
     private directionsService: any;
     private directionsDisplay: any;
    urlPDF :any;
    pagosConfirmacion:any;
    servicios:Observable<any>;
    servicios_confirmacion = []
    objetoCliente:any;
    cliente:Observable<any>;
    contactosDelCliente:Observable<any>;
    contactos: any = [];
    objetoConfirmacion:any;
    objetoContactos:any;
    servicio_obj:any;
    servicios_obj:any;
    confirmacion_obj:any;
    puntosIntermedios_array=[];
    combinaciones_arr=[];
    seccion='';
    mi_trosten_seccion='tipo1';
    camionetas_seccion='tipo1';
    consideracionesData:any = { horas_extras: [], cancelaciones: [], reprogramaciones: [] };
    nombreAgente:any;
    windowInstance:any;
    montoPagado:any;
    tipoUnidad:any;

    info_operador:any;
    info_unidad:any;
    validaciones:any = {
        asignado:false,
        hasPuntosIntermedios:false,
        hasConceptosAdicionales:false,
        servicioMenos24hrs:false
    }

    id_link_contratante:any;
    id_link_coordinador:any;
    id_link_usuario:any;
    private currentUser:any; // Usuario actual


    rutas_planeadas_txt:any = []

    montoConfirmado:number = 0;
    showPagos:boolean = false;

    verPagos()
    {
        this.showPagos = true
    }

    checkIfMillisecondsAreLessThan24Hours(date){
        var currentDate = new Date();
        var dateToCheck = new Date(date);
        var diff = dateToCheck.getTime() - currentDate.getTime();
        var diffHours = Math.ceil(diff / (1000 * 3600));
        if(diffHours > 24){
            return false;
        }else{
            return true;
        }
    }

    openLink()
    {
        window.open('https://www.trosten.com/responsabilidad-social/','_blank')
    }

    fakeFactura()
    {
        console.log('fake factura')
    }

    marcarComoLeida() {
        this.confirmacionesService.marcarComoLeida(this.confirmacionId)
            .catch(error => console.error(error));
    }

    getUTCDate(date){
        var d = new Date(date)
        var d_utc = new Date(Date.UTC(
            d.getUTCFullYear(),
            d.getUTCMonth(),
            d.getUTCDate(),
            d.getUTCHours(),
            d.getUTCMinutes(),
            d.getUTCSeconds()
          ));
        return d_utc;
    }

    getTextoEstatusPago(pago)
    {
        if( pago.aprobacionFinanzas && pago.estatus == 'Pagado')
        {
            return 'CONFIRMADO';
        }
        else if(!pago.aprobacionFinanzas && pago.estatus == 'Pagado')
        {
            return 'PENDIENTE DE VALIDACIÓN';
        } else if(pago.estatus == 'Rechazado')
        {
            return 'RECHAZADO';
        }
            
        return 'PENDIENTE DE VALIDACIÓN';
    }

    getTipoUnidad(unidad_validar){
        //const unidad_validar = this.servicios_obj[0].unidades_solicitadas[0].tipoUnidad;
        //console.log("unidad_validad",this.servicios_obj[0].unidades_solicitadas[0].tipoUnidad)
        if(unidad_validar.includes("Tipo 1")){
            return "assets/nueva_confirmacion/tipo1.png";
        }
        if(unidad_validar.includes("Tipo 2") && !unidad_validar.includes("Lujo")){
            return "assets/nueva_confirmacion/tipo2.png";
        }
        if(unidad_validar.includes("Tipo 2") && unidad_validar.includes("Lujo")){
            return "assets/nueva_confirmacion/tipo2DeLujo.png";
        }
        if(unidad_validar.includes("Tipo 3")){
            return "assets/nueva_confirmacion/tipo3.png";
        }
    }

    getImagenConcepto(concepto){
        if(concepto.includes("Silla de Bebe")){
            return "assets/nueva_confirmacion/servicios_adicionales/sillaBebe.png";
        }
        if(concepto.includes("Hospedaje")){
            return "assets/nueva_confirmacion/servicios_adicionales/hospedaje.png";
        }
        if(concepto.includes("Entradas")){
            return "assets/nueva_confirmacion/servicios_adicionales/entradas.png";
        }
        if(concepto.includes("Casetas")){
            return "assets/nueva_confirmacion/servicios_adicionales/casetas.png";
        }
        if(concepto.includes("Otros")){
            return "assets/nueva_confirmacion/servicios_adicionales/otros.png";
        }
        if(concepto.includes("Host")){
            return "assets/nueva_confirmacion/servicios_adicionales/host.png";
        }
        if(concepto.includes("Alimentos")){
            return "assets/nueva_confirmacion/servicios_adicionales/alimentos.png";
        }
        return "assets/nueva_confirmacion/servicios_adicionales/defaultConcepto.jpg"
    }

    getInfoFromTurismoDB(){
        this.confirmacionesService.getInfoRutaTurismoEnPlaneacion(this.confirmacionId).take(1).subscribe(res => {
            if(res["rutas"])
            {
                res["rutas"] = JSON.parse(res["rutas"])
                if(res["rutas"].length==0)
                {
                    this.validaciones.asignado = false;
                }
                else {
                    let rutas = [];
                    rutas = res["rutas"];

                    var rutas_planeadas_txt_aux = []
                    var asignado_aux = false;
                    var unidad_aux;
                    rutas.forEach(function (value,index)
                    {
                        if(value.operador && value.unidad)
                        {
                            asignado_aux = true;
                            var operador = JSON.parse(value.operador);
                            var operadorAsignado = operador.key;
                            var unidad = JSON.parse(value.unidad);
                            unidad_aux = unidad
                            var operador_txt = operador.nombre
                            console.log("operador",operador)
                            if(operador.key)
                            {
                                this.personalService.obtenerUsuario(operador.key).valueChanges().take(1).subscribe(operador=>{
                                    var _tel = operador.informacionPersonal.telefono;
               var _cel = operador.informacionPersonal.celular;
               var operador_txt_tel = _tel ? _tel : (_cel ? _cel : 'NA');
                                    var unidad_txt =
                                    ((unidad.marca != '' && unidad.marca) ? ""+unidad.marca : '') +
                                    ((unidad.placasFederal != '' && unidad.placasFederal && unidad.placasFederal != '-') ? " / Placas: "+unidad.placasFederal : '')+
                                    ((unidad.placasEstatales != '' && unidad.placasEstatales && unidad.placasEstatales != '-' ) ? " / Placas: "+unidad.placasEstatales : '')

                                    var unidad_txt_tipo = ((unidad.tipoDeUnidad != '' && unidad.tipoDeUnidad) ? " / Tipo: "+unidad.tipoDeUnidad : '') +
                                        ((unidad.rotulo != '' && unidad.rotulo) ? " / Rótulo: "+unidad.rotulo : '')

                                    rutas_planeadas_txt_aux.push({operador_txt:operador_txt, operador_txt_tel:operador_txt_tel, unidad_txt:unidad_txt, unidad_txt_tipo:unidad_txt_tipo,operadorAsignado})

                                    this.validaciones.asignado = asignado_aux;
                                    this.cdRef.detectChanges();
                                    this.rutas_planeadas_txt = rutas_planeadas_txt_aux
                                    if(this.rutas_planeadas_txt.length==0)
                                    {
                                        this.validaciones.asignado = false;
                                    }
                                })
                            }
                        }
                    }.bind(this))
                }
            }
        })
    }

    ngOnInit() {
        this.activatedRoute.params.forEach((params:Params) => {
            this.confirmacionId = params['id'];
        });
        this.cargarConsideracionesAdicionales();
        let departamento = window.localStorage.getItem("departamentoRolUsuario");
        //console.log("departamento",departamento)
        
        if(departamento=="Ventas" || departamento=="GYO_Super_Admin" || departamento=="Admin")
        {
            this.getInfoFromTurismoDB();
                this.confirmacion = this.confirmacionesService.obtenerConfirmacion(this.confirmacionId).valueChanges().take(1);
                this.servicios = this.serviciosService.obtenerServiciosDeConfirmacion(this.confirmacionId).snapshotChanges().take(1)
                    .map(servicios => {
                        let serviciosArr = [];
                        servicios.forEach(servicio => {
                            const $key = servicio.payload.doc.id;
                            const data = { $key, ...servicio.payload.doc.data() };
                            serviciosArr.push(data);
                        });
                        this.servicios_confirmacion = serviciosArr;
                        this.actualizarCodigoDeBarrasOxxo();

                        this.validaciones.servicioMenos24hrs = this.checkIfMillisecondsAreLessThan24Hours(this.servicios_confirmacion[0].inicioDeServicio)

                        return serviciosArr.sort((a: any, b: any) => {
                            if(a.numeroDeServicio < b.numeroDeServicio) return -1;
                            if(a.numeroDeServicio > b.numeroDeServicio) return 1;
                        });

                    });
                this.confirmacion.subscribe(confirmacion => {
                    for (var idServicio in confirmacion.servicios) {
                        this.arregloServicios.push({idServicio,...confirmacion.servicios[idServicio]})
                    }

                    this.objetoConfirmacion= confirmacion
                    this.confirmacion_obj = confirmacion
                    this.actualizarCodigoDeBarrasOxxo();

                    if(this.confirmacion_obj.estatus=='Cancelada')
                    {
                        this.confirmacion_cancelada = true;
                    }
                    // Obtiene la información del cliente
                    this.objetoContactos= confirmacion.contactosNotificados
                    this.cliente = this.clienteServices.obtenerCliente(confirmacion.cliente).snapshotChanges().take(1)
                        .map(cliente => {
                            const $key = cliente.payload.key;
                            const data = { $key, ...cliente.payload.val() };
                            this.objetoCliente= data


                            this.servicios.subscribe(servicios => {
                                let servicios_arr= [];
                                let servicioConfirmacion = ""
                                for (var idServicio in this.objetoConfirmacion.servicios) {
                                    //servicios_arr.push(this.objetoConfirmacion.servicios[idServicio])
                                    servicioConfirmacion = idServicio;
                                    servicios.forEach(servicio=> {
                                        servicios_arr.push(servicio)
                                        if(servicio.servicio == idServicio)
                                        {
                                            if(!servicio.indicacionesEspeciales)
                                            servicio.indicacionesEspeciales = this.objetoConfirmacion.servicios[idServicio].indicacionesEspeciales;
                                            if(!servicio.notas)
                                            servicio.notas = this.objetoConfirmacion.servicios[idServicio].notas;
                                            if(!servicio.notasOperaciones)
                                            servicio.notasOperaciones = this.objetoConfirmacion.servicios[idServicio].notasOperaciones;
                                            servicio.combinacion = this.objetoConfirmacion.servicios[idServicio].combinacion;

                                            const currentPuntos = servicio.puntosIntermedios ? servicio.puntosIntermedios : this.objetoConfirmacion.servicios[idServicio].puntosIntermedios;
                                            servicio.puntos_intermedios = [];
                                            //console.log("currentPuntos2",currentPuntos)

                                            if(currentPuntos)
                                            {
                                                if(currentPuntos.length>0)
                                                {
                                                    this.validaciones.hasPuntosIntermedios = true
                                                    for (var idPunto in currentPuntos) {
                                                        servicio.puntos_intermedios.push(servicio.puntosIntermedios[idPunto])
                                                    }
    
                                                }
                                            }
                                            
                                            servicio.conceptos_adicionales = [];
                                            if(servicio.conceptosAdicionales)
                                            {
                                                for (var idConcepto in servicio.conceptosAdicionales) {
                                                    if(servicio.conceptosAdicionales[idConcepto].visibleCliente)
                                                    servicio.conceptos_adicionales.push(servicio.conceptosAdicionales[idConcepto])
                                                }
                                                if(servicio.conceptos_adicionales.length>0)
                                                {
                                                    this.validaciones.hasConceptosAdicionales = true
                                                }
                                            }    
                                        }
                                    })
                                }

                                let serv_confirmacion  = servicios_arr[0];
                                this.servicio_obj = servicios_arr[0];


                                let numeroUnidades = 0;
                                let tipoUnidad = "";
                                let indicacionesEspeciales = "";

                                //console.log("Servicio Confirmacion",serv_confirmacion)

                                for (const indiceUnidad in serv_confirmacion.combinacion.unidades) {
                                    if (serv_confirmacion.combinacion.unidades.hasOwnProperty(indiceUnidad)) {
                                        const numeroDeUnidades = serv_confirmacion.combinacion.unidades[indiceUnidad];
                                        numeroUnidades = numeroDeUnidades;
                                        tipoUnidad = indiceUnidad;
                                        indicacionesEspeciales = serv_confirmacion.indicacionesEspeciales;
                                    }
                                }

                                //console.log("tipoUnidad",tipoUnidad)

                                this.tipoUnidad = tipoUnidad

                                servicios.forEach(servicio=> {
                                    servicio.unidades_solicitadas = []
                                    for (const indiceUnidad in servicio.unidadesSolicitadas) {
                                        if (servicio.unidadesSolicitadas.hasOwnProperty(indiceUnidad)) {
                                            const res = servicio.unidadesSolicitadas[indiceUnidad];
                                            if(res.numeroDeUnidades)
                                            {

                                                servicio.unidades_solicitadas.push({numeroUnidades:res.numeroDeUnidades,tipoUnidad:indiceUnidad})
                                            }
                                            else
                                            {
                                                if(res>0)
                                                {
                                                    servicio.unidades_solicitadas.push({numeroUnidades:res,tipoUnidad:indiceUnidad})
                                                }
                                            }
                                        }
                                    }

                                })

                                let numeroPasajeros = 0;
                                let tipoDeVenta = "";
                                let inicioServicio = 0;
                                let finDeServicio = 0;
                                let regresoAOrigen = 0;
                                let aliasDestino = "";
                                let aliasOrigen = "";
                                let dirDestino = "";
                                let dirOrigen = "";
                                let notas = "";
                                //console.log("Servicios",servicios )
                                this.servicios_obj = servicios;

                                this.contactosService.obtenerPropiedadContacto(this.servicio_obj.contactos.contratante ,'nombre').valueChanges().take(1).subscribe(nombre=>{
                                    this.nombreContratante = nombre
                                });
                                this.contactosService.obtenerPropiedadContacto(this.servicio_obj.contactos.contratante ,'id_link').valueChanges().take(1).subscribe(id_link=>{
                                    this.id_link_contratante = id_link
                                });
                                this.contactosService.obtenerPropiedadContacto(this.servicio_obj.contactos.coordinador ,'id_link').valueChanges().take(1).subscribe(id_link=>{
                                    this.id_link_coordinador = id_link
                                });
                                this.contactosService.obtenerPropiedadContacto(this.servicio_obj.contactos.usuario ,'id_link').valueChanges().take(1).subscribe(id_link=>{
                                    this.id_link_usuario = id_link
                                });
                                this.contactosService.obtenerPropiedadContacto(this.servicio_obj.contactos.usuario ,'nombre').valueChanges().take(1).subscribe(nombre=>{
                                    this.nombreUsuario = nombre
                                });
                                this.contactosService.obtenerPropiedadContacto(this.servicio_obj.contactos.coordinador ,'nombre').valueChanges().take(1).subscribe(nombre=>{
                                    this.nombreCoordinador = nombre
                                });
                                this.contactosService.obtenerPropiedadContacto(this.servicio_obj.contactos.contratante ,'telefono').valueChanges().take(1).subscribe(nombre=>{
                                    this.telefonoContratante = nombre
                                });
                                this.contactosService.obtenerPropiedadContacto(this.servicio_obj.contactos.usuario ,'telefono').valueChanges().take(1).subscribe(nombre=>{
                                    this.telefonoUsuario = nombre
                                });
                                this.contactosService.obtenerPropiedadContacto(this.servicio_obj.contactos.coordinador ,'telefono').valueChanges().take(1).subscribe(nombre=>{
                                    this.telefonoCoordinador= nombre
                                });

                                for (const indiceServicio in servicios) {
                                    if (servicios.hasOwnProperty(indiceServicio)) {

                                        const res = servicios[indiceServicio];

                                        numeroPasajeros = res.cantidadDePasajeros;
                                        tipoDeVenta = res.tipoDeVenta;
                                        inicioServicio = res.inicioDeServicio;
                                        finDeServicio = res.finDeServicio;
                                        regresoAOrigen = res.regresoAOrigen;
                                        aliasDestino = res.destino.alias;
                                        aliasOrigen = res.origen.alias;
                                        dirDestino = res.destino.direccion;
                                        dirOrigen = res.origen.direccion;
                                        notas = res.notas;
                                    }
                                }

                                if(this.servicios_obj[0].puntosIntermedios)
                                {
                                    if(this.servicios_obj[0].puntosIntermedios.length>0)
                                    {
                                        this.validaciones.hasPuntosIntermedios = true
                                    }
                                }
                                            

                                let origen = this.servicioGeoCode.getGeocode(dirOrigen)
                                let destino = this.servicioGeoCode.getGeocode(dirDestino)

                                let cityO = "";
                                let cityD = "";

                                Observable.zip(origen, destino).subscribe(resultados => {
                                    resultados[0].results.forEach(function(element){
                                        element.address_components.forEach(function(element2){
                                            element2.types.forEach(function(element3){
                                                switch(element3){
                                                    case 'locality':
                                                        cityO = element2.long_name;
                                                        break;
                                                }
                                            })
                                        });
                                    });

                                    resultados[1].results.forEach(function(element){
                                        element.address_components.forEach(function(element2){
                                            element2.types.forEach(function(element3){
                                                switch(element3){
                                                    case 'locality':
                                                        cityD = element2.long_name;
                                                        break;
                                                }
                                            })
                                        });
                                    });

                                    this.contactosDelCliente= this.contactosService.obtenerContactosDeCliente(this.objetoCliente.$key).snapshotChanges().take(1).map((contactos=>{
                                        let arregloContactos = [];
                                        contactos.forEach(contacto => {
                                            let $key = contacto.payload.key;
                                            let data = { $key, ...contacto.payload.val() };
                                            arregloContactos.push(data)
                                        });
                                        this.contactos = arregloContactos;
                                        //console.log("this.contactos",this.contactos)
                                        return arregloContactos
                                    }))
                                    this.contactosDelCliente.subscribe(contactos => {
                                        this.seccion='mi_confirmacion';
                                        this.confirmacionesService.marcarConfirmacionComoEnviada(this.confirmacionId).then(() => {
                                        });
                                    })
                                })
                            })

                            return data;
                        });
                    this.cliente.subscribe(cliente => this.contactosDelCliente = this.contactosService.obtenerContactosDeCliente(cliente.$key).snapshotChanges().take(1).map((contactos=>{
                        let arregloContactos = [];
                        contactos.forEach(contacto => {
                            let $key = contacto.payload.key;
                            let data = { $key, ...contacto.payload.val() };
                            arregloContactos.push(data)
                        });
                        this.contactos = arregloContactos;
                        //console.log("this.contactos",this.contactos)
                        return arregloContactos
                    })));

                    this.personalService.obtenerPropiedadDeUsuario(this.confirmacion_obj.usuarioQueConfirmo ,'informacionPersonal').valueChanges().take(1).subscribe(info_personal=>{
                        //console.log(info_personal)
                        this.nombreAgente = info_personal["nombre"]+ " "+info_personal["apellidoPaterno"] + " "+ info_personal["apellidoMaterno"];
                    });

                    this.pagosServive.listaPagosPorIdConfirmacion(this.confirmacionId).valueChanges().subscribe((pagosDB) =>{
                        this.pagosConfirmacion = pagosDB.filter(p => p["estatus"] != "Cancelado");
                        var montoPagado = 0;
                        var montoConfirmado = 0;
                        this.pagosConfirmacion.forEach(function (element) {
                            if(element.estatus == "Pagado")
                            {
                                montoPagado+= element.total;
                            }
                            if(element.estatus == "Pagado" && element.aprobacionFinanzas)
                            {
                                montoConfirmado+= element.total;
                            }
                        })
                        //this.pagosServive.actualizarMontoPagado(montoPagado,this.confirmacionId)
                        this.montoPagado = montoPagado
                        this.montoConfirmado = montoConfirmado;
                    });

                    //console.log("this.objetoConfirmacion",this.objetoConfirmacion)
                    if(this.objetoConfirmacion.idNegocioHubSpot)
                        {
                            this.confirmacionesService.updateConfirmacionUltimaVezLeidaHubSpot(this.objetoConfirmacion.idNegocioHubSpot ).take(1).subscribe(res3 => {
                                console.log("res4",res3)
                            })
                        }
                });
        }
        else
        {
            this.afAuth.auth.signInWithEmailAndPassword("guest-user@trosten.com", "123456")
                .then(
                    user =>{
                        this.getInfoFromTurismoDB();
                            this.marcarComoLeida();
                            this.confirmacion = this.confirmacionesService.obtenerConfirmacion(this.confirmacionId).valueChanges().take(1);
                            // Obtiene los servicios de la confirmación
                            this.servicios = this.serviciosService.obtenerServiciosDeConfirmacion(this.confirmacionId).snapshotChanges().take(1)
                                .map(servicios => {
                                    let serviciosArr = [];
                                    servicios.forEach(servicio => {
                                        const $key = servicio.payload.doc.id;
                                        const data = { $key, ...servicio.payload.doc.data() };
                                        serviciosArr.push(data);
                                    });
                                    this.servicios_confirmacion = serviciosArr;
                                    this.actualizarCodigoDeBarrasOxxo();
                                    this.validaciones.servicioMenos24hrs = this.checkIfMillisecondsAreLessThan24Hours(this.servicios_confirmacion[0].inicioDeServicio)

                                    return serviciosArr.sort((a: any, b: any) => {
                                        if(a.numeroDeServicio < b.numeroDeServicio) return -1;
                                        if(a.numeroDeServicio > b.numeroDeServicio) return 1;
                                    });
                                });
                            // Obtiene la información del cliente
                            this.confirmacion.subscribe(confirmacion => {
                                for (var idServicio in confirmacion.servicios) {
                                    this.arregloServicios.push({idServicio,...confirmacion.servicios[idServicio]})
                                }

                                this.objetoConfirmacion= confirmacion
                                this.confirmacion_obj = confirmacion
                                this.actualizarCodigoDeBarrasOxxo();
                                // Obtiene la información del cliente
                                this.objetoContactos= confirmacion.contactosNotificados
                                this.cliente = this.clienteServices.obtenerCliente(confirmacion.cliente).snapshotChanges().take(1)
                                    .map(cliente => {
                                        const $key = cliente.payload.key;
                                        const data = { $key, ...cliente.payload.val() };
                                        this.objetoCliente= data

                                        //console.log("this.objetoCliente",this.objetoCliente)

                                        //console.log("Obj Confirmacion",this.objetoConfirmacion)

                                        this.servicios.subscribe(servicios => {
                                            let servicios_arr= [];
                                            let servicioConfirmacion = ""
                                            for (var idServicio in this.objetoConfirmacion.servicios) {
                                                servicioConfirmacion = idServicio;
                                                servicios.forEach(servicio=> {
                                                    servicios_arr.push(servicio)
                                                    if(servicio.servicio == idServicio)
                                                    {
                                                        if(!servicio.indicacionesEspeciales)
                                                            servicio.indicacionesEspeciales = this.objetoConfirmacion.servicios[idServicio].indicacionesEspeciales;
                                                        if(!servicio.notas)
                                                            servicio.notas = this.objetoConfirmacion.servicios[idServicio].notas;
                                                        if(!servicio.notasOperaciones)
                                                            servicio.notasOperaciones = this.objetoConfirmacion.servicios[idServicio].notasOperaciones;
                                                        servicio.combinacion = this.objetoConfirmacion.servicios[idServicio].combinacion;

                                                        servicio.puntos_intermedios = [];
                                                        const currentPuntos = servicio.puntosIntermedios ? servicio.puntosIntermedios : this.objetoConfirmacion.servicios[idServicio].puntosIntermedios;
                                                        //console.log("currentPuntos",currentPuntos)
                                                        
                                                        if(currentPuntos)
                                                    {
                                                        if(currentPuntos.length>0)
                                                                {
                                                                    this.validaciones.hasPuntosIntermedios = true

                                                                    for (var idPunto in currentPuntos) {
                                                                        servicio.puntos_intermedios.push(currentPuntos[idPunto])
                                                                    }
                                                                }
                                                    }
                                                        
                                                        servicio.conceptos_adicionales = [];
                                                        if(servicio.conceptosAdicionales)
                                                        {
                                                            for (var idConcepto in servicio.conceptosAdicionales) {
                                                                if(servicio.conceptosAdicionales[idConcepto].visibleCliente)
                                                                servicio.conceptos_adicionales.push(servicio.conceptosAdicionales[idConcepto])
                                                            }

                                                            if(servicio.conceptos_adicionales.length>0)
                                                            {
                                                                this.validaciones.hasConceptosAdicionales = true
                                                            }
                                                        }    
                                                    }
                                                })
                                            }

                                            let serv_confirmacion  = servicios_arr[0];
                                            this.servicio_obj = servicios_arr[0];


                                            let numeroUnidades = 0;
                                            let tipoUnidad = "";
                                            let indicacionesEspeciales = "";


                                            for (const indiceUnidad in serv_confirmacion.combinacion.unidades) {
                                                if (serv_confirmacion.combinacion.unidades.hasOwnProperty(indiceUnidad)) {
                                                    const numeroDeUnidades = serv_confirmacion.combinacion.unidades[indiceUnidad];
                                                    numeroUnidades = numeroDeUnidades;
                                                    tipoUnidad = indiceUnidad;
                                                    indicacionesEspeciales = serv_confirmacion.indicacionesEspeciales;
                                                }
                                            }
                                            console.log("tipoUnidad",tipoUnidad)
                                            this.tipoUnidad = tipoUnidad
                                            servicios.forEach(servicio=> {
                                                servicio.unidades_solicitadas = []
                                                for (const indiceUnidad in servicio.unidadesSolicitadas) {
                                                    if (servicio.unidadesSolicitadas.hasOwnProperty(indiceUnidad)) {
                                                        const res = servicio.unidadesSolicitadas[indiceUnidad];
                                                        if(res.numeroDeUnidades)
                                                        {

                                                            servicio.unidades_solicitadas.push({numeroUnidades:res.numeroDeUnidades,tipoUnidad:indiceUnidad})
                                                        }
                                                        else
                                                        {
                                                            if(res>0)
                                                            {
                                                                servicio.unidades_solicitadas.push({numeroUnidades:res,tipoUnidad:indiceUnidad})
                                                            }
                                                        }
                                                    }
                                                }
                                            })

                                            let numeroPasajeros = 0;
                                            let tipoDeVenta = "";
                                            let inicioServicio = 0;
                                            let finDeServicio = 0;
                                            let regresoAOrigen = 0;
                                            let aliasDestino = "";
                                            let aliasOrigen = "";
                                            let dirDestino = "";
                                            let dirOrigen = "";
                                            let notas = "";
                                                console.log("Servicios",servicios )
                                            this.servicios_obj = servicios;
                                            this.contactosService.obtenerPropiedadContacto(this.servicio_obj.contactos.contratante ,'nombre').valueChanges().take(1).subscribe(nombre=>{
                                                this.nombreContratante = nombre
                                            });
                                            this.contactosService.obtenerPropiedadContacto(this.servicio_obj.contactos.contratante ,'id_link').valueChanges().take(1).subscribe(id_link=>{
                                                this.id_link_contratante = id_link
                                            });
                                            this.contactosService.obtenerPropiedadContacto(this.servicio_obj.contactos.usuario ,'nombre').valueChanges().take(1).subscribe(nombre=>{
                                                this.nombreUsuario = nombre
                                            });
                                            this.contactosService.obtenerPropiedadContacto(this.servicio_obj.contactos.coordinador ,'nombre').valueChanges().take(1).subscribe(nombre=>{
                                                this.nombreCoordinador = nombre
                                            });
                                            this.contactosService.obtenerPropiedadContacto(this.servicio_obj.contactos.contratante ,'telefono').valueChanges().take(1).subscribe(nombre=>{
                                                this.telefonoContratante = nombre
                                            });
                                            this.contactosService.obtenerPropiedadContacto(this.servicio_obj.contactos.usuario ,'telefono').valueChanges().take(1).subscribe(nombre=>{
                                                this.telefonoUsuario = nombre
                                            });
                                            this.contactosService.obtenerPropiedadContacto(this.servicio_obj.contactos.coordinador ,'telefono').valueChanges().take(1).subscribe(nombre=>{
                                                this.telefonoCoordinador= nombre
                                            });


                                            for (const indiceServicio in servicios) {
                                                if (servicios.hasOwnProperty(indiceServicio)) {

                                                    const res = servicios[indiceServicio];

                                                    numeroPasajeros = res.cantidadDePasajeros;
                                                    tipoDeVenta = res.tipoDeVenta;
                                                    inicioServicio = res.inicioDeServicio;
                                                    finDeServicio = res.finDeServicio;
                                                    regresoAOrigen = res.regresoAOrigen;
                                                    aliasDestino = res.destino.alias;
                                                    aliasOrigen = res.origen.alias;
                                                    dirDestino = res.destino.direccion;
                                                    dirOrigen = res.origen.direccion;
                                                    notas = res.notas;
                                                }
                                            }

                                            if(this.servicios_obj[0].puntosIntermedios)
                                            {
                                                if(this.servicios_obj[0].puntosIntermedios.length>0)
                                                {
                                                    this.validaciones.hasPuntosIntermedios = true
                                                }
                                            }

                                            let origen = this.servicioGeoCode.getGeocode(dirOrigen)
                                            let destino = this.servicioGeoCode.getGeocode(dirDestino)

                                            let cityO = "";
                                            let cityD = "";

                                            Observable.zip(origen, destino).subscribe(resultados => {
                                                resultados[0].results.forEach(function(element){
                                                    element.address_components.forEach(function(element2){
                                                        element2.types.forEach(function(element3){
                                                            switch(element3){
                                                                case 'locality':
                                                                    cityO = element2.long_name;
                                                                    break;
                                                            }
                                                        })
                                                    });
                                                });

                                                resultados[1].results.forEach(function(element){
                                                    element.address_components.forEach(function(element2){
                                                        element2.types.forEach(function(element3){
                                                            switch(element3){
                                                                case 'locality':
                                                                    cityD = element2.long_name;
                                                                    break;
                                                            }
                                                        })
                                                    });
                                                });

                                                this.contactosDelCliente= this.contactosService.obtenerContactosDeCliente(this.objetoCliente.$key).snapshotChanges().take(1).map((contactos=>{
                                                    let arregloContactos = [];
                                                    contactos.forEach(contacto => {
                                                        let $key = contacto.payload.key;
                                                        let data = { $key, ...contacto.payload.val() };
                                                        arregloContactos.push(data)
                                                    });
                                                    this.contactos = arregloContactos;
                                                    console.log("this.contactos",this.contactos)
                                                    return arregloContactos
                                                }))
                                                this.contactosDelCliente.subscribe(contactos => {

                                                    this.seccion='mi_confirmacion';
                                                    this.confirmacionesService.marcarConfirmacionComoEnviada(this.confirmacionId).then(() => {
                                                    });
                                                })
                                            })
                                        })

                                        return data;
                                    });
                                // Obtiene los contactos del cliente
                                this.cliente.subscribe(cliente => this.contactosDelCliente = this.contactosService.obtenerContactosDeCliente(cliente.$key).snapshotChanges().take(1).map((contactos=>{
                                    let arregloContactos = [];
                                    contactos.forEach(contacto => {
                                        let $key = contacto.payload.key;
                                        let data = { $key, ...contacto.payload.val() };
                                        arregloContactos.push(data)
                                    });
                                    this.contactos = arregloContactos;
                                    console.log("this.contactos",this.contactos)
                                    return arregloContactos
                                })));

                                this.personalService.obtenerPropiedadDeUsuario(this.confirmacion_obj.usuarioQueConfirmo ,'informacionPersonal').valueChanges().take(1).subscribe(info_personal=>{
                                    console.log(info_personal)
                                    this.nombreAgente = info_personal["nombre"]+ " "+info_personal["apellidoPaterno"] + " "+ info_personal["apellidoMaterno"];
                                });

                                this.pagosServive.listaPagosPorIdConfirmacion(this.confirmacionId).valueChanges().subscribe((pagosDB) =>{
                                    this.pagosConfirmacion = pagosDB.filter(p => p["estatus"] != "Cancelado");
                                    var montoPagado = 0;
                                    var montoConfirmado = 0;
                                    this.pagosConfirmacion.forEach(function (element) {
                                        if(element.estatus == "Pagado")
                                        {
                                            montoPagado+= element.total;
                                        }
                                        if(element.estatus == "Pagado" && element.aprobacionFinanzas)
                                        {
                                            montoConfirmado+= element.total;
                                        }
                                    })
                                    //this.pagosServive.actualizarMontoPagado(montoPagado,this.confirmacionId)
                                    this.montoPagado = montoPagado
                                    this.montoConfirmado = montoConfirmado;
                                });

                                console.log("this.confirmacion",this.confirmacion)
                                if(this.objetoConfirmacion.idNegocioHubSpot)
                                    {
                                        this.confirmacionesService.updateConfirmacionUltimaVezLeidaHubSpot(this.objetoConfirmacion.idNegocioHubSpot ).take(1).subscribe(res3 => {
                                            console.log("res4",res3)
                                        })
                                    }
                            });
                    },
                    error => {
                        console.log("error_login")
                    });
        }

        
    }
    limpiarYAsignar(opcion){
        document.getElementById('como_confirmar_mi_servicio').classList.remove("header-seleccionado");
        document.getElementById('formas_de_pago').classList.remove("header-seleccionado");
        //document.getElementById('servicios_adicionales').classList.remove("header-seleccionado");
        document.getElementById('preguntas_frecuentes').classList.remove("header-seleccionado");
        document.getElementById('consideraciones_adicionales').classList.remove("header-seleccionado");
        document.getElementById('mi_confirmacion').classList.remove("header-seleccionado");
        document.getElementById('mi_trosten').classList.remove("header-seleccionado");
        document.getElementById('responsabilidad_social').classList.remove("header-seleccionado");
        document.getElementById(opcion).classList.add("header-seleccionado");
    }
    cambiarSeccion(opcion){
        this.limpiarYAsignar(opcion)
        this.seccion= opcion;
        console.log("this.seccion",this.seccion)
    }
    cambiarSeccion_Mi_Trosten(opcion){
        this.mi_trosten_seccion= opcion;
    }
    cambiarSeccion_Camionetas(opcion){
        this.camionetas_seccion= opcion;
    }

    removeElement(id) {
        var elem = document.getElementById(id);
        return elem.parentNode.removeChild(elem);
    }


    printDiv(divName) {
        window.print();
        return true;
    }

    copyToClipboard()
    {
        var inputc = document.body.appendChild(document.createElement("input"));
        inputc.value = window.location.href;
        inputc.select();
        document.execCommand('copy');
        inputc.parentNode.removeChild(inputc);
        alert("Se ha copiado correctamente el link a este documento!");
    }

    configurarMapa(indice, servicio){
        // Almacena las variables del mapa y de los inputs de auto complete
        let mapas = document.getElementsByClassName("google-map");
        let opcionesMapa = {
            center: { lat: 19.273437, lng: -99.661012 }, // Ubicación de Trosten
            zoom: 10,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        };
        this.map = new google.maps.Map(mapas[indice], opcionesMapa);
        this.directionsService = new google.maps.DirectionsService;
        this.directionsDisplay = new google.maps.DirectionsRenderer({
            draggable: true
        });

        this.directionsDisplay.setMap( this.map);
        this.googleService.calcularRuta(this.directionsService,this.directionsDisplay, servicio)
    }

    verMenu(opcion){
      this.opcion= opcion;
    }

    imprimirPantalla(){
        window.print();
    }
    centrarTexto(txt, options, x, y,doc) {
        options = options ||{};
        if( options.align == "center" ){
            var fontSize = doc.internal.getFontSize();
            var txtWidth = doc.getStringUnitWidth(txt) * fontSize / doc.internal.scaleFactor;
            var pageWidth = doc.internal.pageSize.width;
            txtWidth = doc.getStringUnitWidth(txt)*fontSize/doc.internal.scaleFactor;
            x = ( pageWidth - txtWidth ) / 2;
        }

        doc.text(txt,x,y);
    }
    crearPDF(servicio,noServicio){
        let doc = new jsPDF('p','','',true) //Nuevo objeto jspdf
        let numeroServicio = noServicio+1;
        //Logo en Base64
        let logo= imgCotizacion;
        doc.rect(0, 0, 210, 21, 'F'); //Fondo negro
        doc.addImage(logo, 'PNG', -10, -24, 230, 60, undefined,'FAST'); //imgb64,type, x, y , ancho, largo
        doc.setFontSize(12);
        doc.setTextColor(242, 148, 25);
        this.centrarTexto("ID:"+ this.confirmacionCompleta.idTrosten,{align: "center"},0,27,doc);
        this.centrarTexto('¡Hola '+ this.nombreCliente +'!',{align: "center"},0,34,doc);
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(8);
        this.centrarTexto('AGRADECEMOS SU CONFIANZA Y PREFERENCIA EN NUESTRO SERVICIO,',{align: "center"},0,40,doc);
        this.centrarTexto('A CONTINUACIÓN LE PRESENTAMOS LA CONFIRMACIÓN REQUERIDA PARA SU PRÓXIMO VIAJE',{align: "center"},0,45,doc);
        doc.addImage(monosVerdes, 'PNG', 70, 40, 80, 25, undefined,'FAST'); //imgb64,type, x, y , ancho, largo
        doc.rect(0, 60, 210, 10, 'F'); //pInicial, altura, p.final ancho
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(9);
        this.centrarTexto('Servicio '+ numeroServicio.toString(),{align: "center"},0,65,doc);
        doc.setFontSize(12);
        doc.setTextColor(242, 148, 25);
        this.centrarTexto('Viaje '+ this.confirmacionCompleta.tipoDeVenta +': '+ this.confirmacionCompleta.aliasOrigen + ' - '+ this.confirmacionCompleta.aliasDestino ,{align: "center"},0,80,doc);
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        doc.setTextColor(242, 148, 25);
        doc.text(10, 90, 'Origen: ');
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(8);
        let origen= doc.splitTextToSize(this.confirmacionCompleta.aliasOrigen, 50);
        doc.text(10, 95, origen);
        doc.setFontSize(10);
        doc.setTextColor(242, 148, 25);
        doc.text(80, 90, 'Destino: ');
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(8);
        let destino= doc.splitTextToSize(this.confirmacionCompleta.aliasDestino, 50);
        doc.text(80, 95, destino);
        doc.setFontSize(10);
        doc.setTextColor(242, 148, 25);
        doc.text(150, 90, 'Total de pasajeros: ');
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(8);
        let totalPasajeros= doc.splitTextToSize(servicio.parametros.cantidadDePasajeros.toString(), 50);
        doc.text(165, 95, totalPasajeros);
        doc.setFontSize(10);
        doc.setTextColor(242, 148, 25);
        doc.text(10, 105, ' Inicio de servicio: ');
        doc.text(80, 105, ' Fin de servicio: ');
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(8);
        this.servicioService.obtenerServiciosPorPlantillaDeServicio(servicio.idServicio).valueChanges().subscribe(res=>{
            if(new Date(res[0]['inicioDeServicio']).getHours() < 12){
                doc.text(10,110,new Date(res[0]['inicioDeServicio']).toLocaleString().toString() + ' am')
            }else
                doc.text(10,110,new Date(res[0]['inicioDeServicio']).toLocaleString().toString() + ' pm')
            if(new Date(res[0]['finDeServicio']).getHours() < 12){
                doc.text(80,110,new Date(res[0]['finDeServicio']).toLocaleString().toString() + ' am')
            }else
                doc.text(80,110,new Date(res[0]['finDeServicio']).toLocaleString().toString() + ' pm')

        if(servicio.indicacionesEspeciales != undefined || servicio.indicacionesEspeciales != ""){
            doc.setFontSize(10);
            doc.setTextColor(242, 148, 25);
            doc.text(10, 120, 'Indicaciones especiales: ');
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(8);
            let indicaciones= doc.splitTextToSize(servicio.indicacionesEspeciales, 100);
            doc.text(10, 125, indicaciones);
        }else{
                doc.setFontSize(12);
                doc.text(10, 120, 'Indicaciones especiales: ');
                doc.setFontSize(10);
                let indicaciones= doc.splitTextToSize('Este servicio no cuenta con indicaciones especiales', 100);
                doc.text(10, 125, indicaciones);
        }

        let anchoTipo= 10;
        for (const keyUnidad in servicio.combinacion.unidades) {
            if (servicio.combinacion.unidades.hasOwnProperty(keyUnidad)) {
                debugger
                const unidad = servicio.combinacion.unidades[keyUnidad];
                switch (keyUnidad) {
                    case 'Tipo 1':
                        doc.setTextColor(0, 0, 0);
                        doc.text(anchoTipo, 148, keyUnidad+': Toyota hiace o similar');
                        doc.text(anchoTipo, 153 ,' (10 a 14 pasajeros)')
                        break;
                    case 'Tipo 2':
                        doc.setTextColor(0, 0, 0);
                        doc.text(anchoTipo, 148, keyUnidad+': Sprinter');
                        doc.text(anchoTipo, 153 ,' (20 pasajeros) ')
                        break;
                    case 'Auto':
                        doc.setTextColor(0, 0, 0);
                        doc.text(anchoTipo, 148,keyUnidad+' básicos y ejecutivos tipo sedán');
                        doc.text(anchoTipo, 153 ,' (3 a 4 pasajeros)')

                        break;
                    case 'Lujo':
                        doc.setTextColor(0, 0, 0);
                        doc.text(anchoTipo, 148, keyUnidad+': Sprinter de Lujo');
                        doc.text(anchoTipo, 153 ,' (16 a 17 pasajeros)')
                        break;
                    default:
                        break;
                }
                anchoTipo = anchoTipo + 55
            }
        }
        doc.setFontSize(10);
        doc.setTextColor(203, 213, 1);
        doc.text(10, 165, 'Paradas del viaje');
        doc.text(130, 165, 'Conceptos Adicionales');
        this.centrarTexto('Precio por unidades contratadas' ,{align: "center"},0,137,doc);
        doc.setTextColor(242, 148, 25);
        this.centrarTexto('Total: $ '+servicio.combinacion.precio ,{align: "center"},0,142,doc);

        let index=1
        let espacio=173
        this.arregloParadas.forEach(parada=>{
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(8);
            let anchoTexto =doc.splitTextToSize(index +'. ' +parada.direccion, 80);
            doc.text(10, espacio, anchoTexto);
            index++
            espacio= espacio+5
        })
        let indexConceptos=1
        let espacioConceptos=173
        for (const key in servicio.conceptosAdicionales) {
            if (servicio.conceptosAdicionales.hasOwnProperty(key)) {
                const element = servicio.conceptosAdicionales[key];
                doc.text(130, espacioConceptos, +indexConceptos+'. '+ element.descripcion+ ': $'+ element.precio);
                espacioConceptos = espacioConceptos+8
            }
        }

        doc.addImage(confirmRules, 'PNG', -10, 205, 230, 115, undefined,'FAST'); //imgb64,type, x, y , ancho, largo

        doc.save('doc.pdf'); //Se crea el pdf final
    })
    }

    getCantidadDescuento(){
        let descuentoAQuitar = 0;
        if(this.objetoConfirmacion.descuentoAdicional.descuentoAQuitar)
        {
            descuentoAQuitar = this.objetoConfirmacion.descuentoAdicional.descuentoAQuitar
        }
        if(this.objetoConfirmacion.descuentoMarketing.descuentoAQuitar)
        {
            descuentoAQuitar = this.objetoConfirmacion.descuentoMarketing.descuentoAQuitar
        }
        if(this.objetoConfirmacion.descuentoAdmin.descuentoAQuitar)
        {
            descuentoAQuitar = this.objetoConfirmacion.descuentoAdmin.descuentoAQuitar
        }

        return descuentoAQuitar
    }

    private actualizarCodigoDeBarrasOxxo(): void {
        let primerServicio = this.servicios_confirmacion && this.servicios_confirmacion.length > 0 ? this.servicios_confirmacion[0] : null;
        let idTrosten = this.confirmacion_obj && this.confirmacion_obj.idTrosten ? this.confirmacion_obj.idTrosten : null;
        let inicioDeServicio = primerServicio && primerServicio.inicioDeServicio ? primerServicio.inicioDeServicio : null;

        if (!idTrosten || !inicioDeServicio) {
            this.codigoDeBarrasOxxo = null;
            this.codigoDeBarrasOxxoImagen = null;
            return;
        }

        let numeroDeViaje = this.obtenerNumeroDeViajeOxxo(idTrosten);
        let fechaVencimiento = this.obtenerFechaVencimientoOxxo(inicioDeServicio);

        if (!numeroDeViaje || !fechaVencimiento) {
            this.codigoDeBarrasOxxo = null;
            this.codigoDeBarrasOxxoImagen = null;
            return;
        }

        let codigoBase = '05' + numeroDeViaje + fechaVencimiento;
        let digitoVerificador = this.calcularDigitoVerificadorOxxo(codigoBase);

        if (digitoVerificador === null) {
            this.codigoDeBarrasOxxo = null;
            this.codigoDeBarrasOxxoImagen = null;
            return;
        }

        this.codigoDeBarrasOxxo = codigoBase + digitoVerificador;
        this.codigoDeBarrasOxxoImagen = this.generarImagenCodigoDeBarrasOxxo(this.codigoDeBarrasOxxo);
    }

    private obtenerNumeroDeViajeOxxo(idTrosten: any): string {
        let digitos = String(idTrosten || '').replace(/\D/g, '');

        if (digitos.length < 5) {
            return null;
        }

        return digitos.slice(-5);
    }

    private obtenerFechaVencimientoOxxo(inicioDeServicio: any): string {
        let fechaInicio = this.obtenerFechaDesdeValor(inicioDeServicio);

        if (!fechaInicio) {
            return null;
        }

        let fechaVencimiento = new Date(fechaInicio.getTime() - (72 * 60 * 60 * 1000));

        return this.completarConCeros(fechaVencimiento.getDate(), 2)
            + this.completarConCeros(fechaVencimiento.getMonth() + 1, 2)
            + this.completarConCeros(fechaVencimiento.getFullYear() % 100, 2);
    }

    private obtenerFechaDesdeValor(valor: any): Date {
        if (!valor) {
            return null;
        }

        if (valor instanceof Date) {
            return isNaN(valor.getTime()) ? null : valor;
        }

        if (typeof valor === 'number') {
            let fechaNumero = new Date(valor);
            return isNaN(fechaNumero.getTime()) ? null : fechaNumero;
        }

        if (valor.seconds) {
            let fechaTimestamp = new Date(valor.seconds * 1000);
            return isNaN(fechaTimestamp.getTime()) ? null : fechaTimestamp;
        }

        let fecha = new Date(valor);
        return isNaN(fecha.getTime()) ? null : fecha;
    }

    private calcularDigitoVerificadorOxxo(codigoBase: string): number {
        if (!codigoBase || codigoBase.length !== 13 || !/^\d+$/.test(codigoBase)) {
            return null;
        }

        let suma = 0;

        for (let i = 0; i < codigoBase.length; i++) {
            suma += parseInt(codigoBase.charAt(i), 10) * (i + 1);
        }

        return suma % 10;
    }

    private generarImagenCodigoDeBarrasOxxo(codigo: string): string {
        if (!codigo) {
            return null;
        }

        try {
            let canvas = ioBarcode.CODE128C(codigo, {
                width: 2,
                height: 70,
                quite: 0,
                displayValue: false,
                backgroundColor: '#ffffff',
                lineColor: '#000000'
            });

            return canvas.toDataURL('image/png');
        } catch (error) {
            try {
                let canvas = ioBarcode.CODE128B(codigo, {
                    width: 2,
                    height: 70,
                    quite: 0,
                    displayValue: false,
                    backgroundColor: '#ffffff',
                    lineColor: '#000000'
                });

                return canvas.toDataURL('image/png');
            } catch (fallbackError) {
                return null;
            }
        }
    }

    private completarConCeros(valor: number, longitud: number): string {
        let valorTexto = String(valor);

        while (valorTexto.length < longitud) {
            valorTexto = '0' + valorTexto;
        }

        return valorTexto;
    }

    cargarConsideracionesAdicionales() {
        this.cotizacionesService.getConsideracionesAdicionales().subscribe((data: any) => {
            let items = data || [];
            this.consideracionesData = {
                horas_extras: items.filter(i => i.seccion === 'horas_extras'),
                cancelaciones: items.filter(i => i.seccion === 'cancelaciones'),
                reprogramaciones: items.filter(i => i.seccion === 'reprogramaciones')
            };
        });
    }

    getEscenarios(seccion: string): string[] {
        let items = this.consideracionesData[seccion] || [];
        let escenarios = [];
        items.forEach(i => {
            if (escenarios.indexOf(i.escenario) === -1) escenarios.push(i.escenario);
        });
        return escenarios;
    }

    getTiposVehiculo(seccion: string): string[] {
        let items = this.consideracionesData[seccion] || [];
        let tipos = [];
        items.forEach(i => {
            if (tipos.indexOf(i.tipo_vehiculo) === -1) tipos.push(i.tipo_vehiculo);
        });
        return tipos;
    }

    getValor(seccion: string, escenario: string, tipoVehiculo: string): string {
        let items = this.consideracionesData[seccion] || [];
        let item = items.find(i => i.escenario === escenario && i.tipo_vehiculo === tipoVehiculo);
        if (!item) return '';
        return item.valor == 0 ? 'Sin penalización' : '$' + parseFloat(item.valor).toFixed(2);
    }

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/components/confirmacion/confirmacion.component.ts